import { makeApiClient } from './client';

export const mediaKitsApi = makeApiClient(
  `${process.env.NEXT_PUBLIC_MEDIA_KITS_API}/v1`,
);
